import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/home/workspace-setup/add-people',
)({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/home/add-people'),
});
